import React from "react";
import {Box} from "@material-ui/core"
import {Skeleton} from "@material-ui/lab";

const RectangularSkeleton = ({loading, width, height, ...props}) => {
    return (
        <>
            <Box style={{
                display: loading ? 'flex' : 'none'
            }}>
                <Skeleton variant="rect" width={width} height={height}/>
            </Box>
            <Box style={{
                display: loading ? 'none' : 'flex',
                width: '100%'
            }}>
                {props.children}
            </Box>
        </>
    )
}

export default RectangularSkeleton;